import { useGetList } from "react-admin";
import { Vendor } from "@/types";
import { VENDOR_TYPE_CONFIG, VendorAssignmentType } from "./vendorAssignmentShared";

export const useVendorOptions = (
  vendorType: VendorAssignmentType,
  enabled: boolean,
  onError?: (error: unknown) => void
) =>
  useGetList<Vendor>(
    VENDOR_TYPE_CONFIG[vendorType].resource,
    {
      pagination: { page: 1, perPage: 100000 },
      sort: { field: "company_name", order: "ASC" },
      filter: {},
      meta: {
        "X-Fields": "id,company_name",
      },
    },
    {
      enabled,
      onError: (error) => onError?.(error),
    }
  );
